document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.prod-desc-preview').forEach(function (desc) {
    var btn = desc.nextElementSibling;
    if (!btn || !btn.classList.contains('prod-desc-btn')) return;

    if (desc.scrollHeight <= desc.clientHeight) {
      btn.style.display = 'none';
      return;
    }

    btn.addEventListener('click', function () {
      var expanded = desc.classList.toggle('expanded');
      btn.textContent = expanded ? 'Leggi meno' : 'Leggi di più';
      btn.setAttribute('aria-expanded', expanded);
    });
  });
});